global.conmed = global.conmed || {};

conmed.messageModalContainer = function ($) {
    'use strict';
    
    var that = {
        selectors: {
            modal: '#ModalMessage',
            modalCloseBtn: '#ModalMessage .btn-close'
        }
    };

    that.init = function () {
        $(that.selectors.modalCloseBtn).on('click', function (e) {
            e.preventDefault();
            $(that.selectors.modal).hide();
        });
    };

    return that;
}(jQuery);